module.exports = __webpack_public_path__ + "static/img/logo1.c1ae220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sjcw/logo1.png
// module id = towk
// module chunks = 24